import {TAILWIND_SCREENS} from '@aviary/responsiveness/tailwind-screens.config';

export const VIEWPORT_FEATURE_KEY = 'viewport';

export type ViewportSize = keyof typeof TAILWIND_SCREENS;
